<script setup>
import { ref, reactive, nextTick } from 'vue'
import DialogModal from './DialogModal.vue'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'

const emit = defineEmits(['confirmed'])

defineProps({
  title: {
    type: String,
    default: 'Confirm Password',
  },
  content: {
    type: String,
    default: 'For your security, please confirm your password to continue.',
  },
  button: {
    type: String,
    default: 'Confirm',
  },
})

const confirmingPassword = ref(false)

const form = reactive({
  password: '',
  error: '',
  processing: false,
})

const passwordInput = ref(null)

const startConfirmingPassword = () => {
  axios.get('/user/confirmed-password-status').then(response => {
    if (response.data.confirmed) {
      emit('confirmed')
    } else {
      confirmingPassword.value = true

      setTimeout(() => passwordInput.value.focus(), 250)
    }
  })
}

const confirmPassword = () => {
  form.processing = true

  axios.post('/user/confirm-password', {
    password: form.password,
  }).then(() => {
    form.processing = false

    closeModal()
    nextTick().then(() => emit('confirmed'))

  }).catch(error => {
    form.processing = false
    form.error = error.response.data.errors.password[0]
    passwordInput.value.focus()
  })
}

const closeModal = () => {
  confirmingPassword.value = false
  form.password = ''
  form.error = ''
}
</script>

<template>
  <span>
    <span @click="startConfirmingPassword">
      <slot />
    </span>

    <DialogModal :show="confirmingPassword" @close="closeModal">
      <template #title>
        {{ title }}
      </template>

      <template #content>
        {{ content }}

        <div class="mt-4">

          <text-input
            ref="passwordInput"
            v-model="form.password"
            type="password"
            class="mt-1 block w-3/4"
            placeholder="Password"
            @keyup.enter="confirmPassword"
          />
        </div>
      </template>

      <template #footer>
        <button
          class="hover:underline" tabindex="-1" type="button"
          @click="closeModal"
        >Cancel
        </button>

        <LoadingButton
          :loading="form.processing"
          class="btn-indigo ml-auto" type="submit"
          @click="confirmPassword"
        >
          {{ button }}
        </LoadingButton>
      </template>
    </DialogModal>
  </span>
</template>
